export const TaskStatus = {
    TO_DO: "to-do",
    IN_PROGRESS: "in-progress",
    COMPLETED: "completed",
    SKIPPED: "skipped",
    COPYING: "copying",
    COPY_COMPLETE: "copy-complete",
    EDITING: "editing",
    UPLOADING: "uploading",
    ERROR: "error",
    READY: "ready",
    OPEN: "open",
    ACTIVE: "active",
    REDO: "redo",
    WAITING_FOR_CA: "waiting-for-ca",
    DQ_FAILED: "dq-failed",
    PARTIAL_READY: "partial-ready",
    UPLOADED: "uploaded",
    UPLOAD_FAILED: "upload-failed",
    BULK_REJECT_PENDING: "bulk-reject-pending",
    AWAITING_AI_RESULTS: "awaiting-ai-results",
};

export const statusDescription = [
    { text: "Ready", value: TaskStatus.READY },
    { text: "Open", value: TaskStatus.TO_DO },
    { text: "Active", value: TaskStatus.ACTIVE },
    { text: "Partial Ready", value: TaskStatus.PARTIAL_READY },
    { text: "Completed", value: TaskStatus.COMPLETED },
    { text: "Redo", value: TaskStatus.REDO },
    { text: "DQ Failed", value: TaskStatus.DQ_FAILED },
    { text: "Awaiting AI Results", value: TaskStatus.AWAITING_AI_RESULTS },
];
